import type React from "react";

export const SnookerIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  const { width = 50, height = 50, color = "#6a33ff", ...restProps } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={width}
      height={height}
      x="0"
      y="0"
      viewBox="0 0 64 64"
      xmlSpace="preserve"
      {...restProps}
    >
      <title>Snooker icon</title>
      <g>
        <path
          d="M32 20.1c3.3 0 5.8-2.6 5.8-5.8 0-.9-.2-1.8-.6-2.6-.1-.1-1.3-3.3-5.2-3.3-3.8 0-5.1 3.1-5.3 3.3-.4.8-.6 1.6-.6 2.5 0 3.2 2.7 5.9 5.9 5.9z"
          fill={color}
          opacity="1"
          data-original="#000000"
        ></path>
        <path
          d="M62.6 45.3 41.2 8.2c-1.9-3.3-5.4-5.3-9.2-5.3s-7.3 2-9.2 5.3L1.4 45.3c-1.9 3.3-1.9 7.3 0 10.6s5.3 5.3 9.2 5.3h42.8c3.8 0 7.3-2 9.2-5.3 1.9-3.4 1.9-7.3 0-10.6zm-2.7 9c-1.4 2.4-3.8 3.8-6.5 3.8H10.6c-2.7 0-5.1-1.4-6.5-3.8-1.4-2.3-1.4-5.2 0-7.5L25.5 9.7c1.4-2.4 3.8-3.8 6.5-3.8s5.1 1.4 6.5 3.8l21.4 37.1c1.3 2.3 1.3 5.1 0 7.5z"
          fill={color}
          opacity="1"
          data-original="#000000"
        ></path>
        <path
          d="M25.1 32c3.3 0 5.8-2.6 5.8-5.8s-2.6-5.8-5.8-5.8c-2.2 0-4.1 1.2-5.1 3v.1c-2.1 4.3 1 8.5 5.1 8.5zM33 26.2c0 3.2 2.6 5.8 5.8 5.8 3.3 0 5.8-2.6 5.8-5.8s-2.6-5.8-5.8-5.8c-3.1-.1-5.8 2.6-5.8 5.8z"
          fill={color}
          opacity="1"
          data-original="#000000"
        ></path>
        <circle
          cx="45.8"
          cy="38.2"
          r="5.8"
          fill={color}
          opacity="1"
          data-original="#000000"
        ></circle>
        <circle
          cx="32"
          cy="38.2"
          r="5.8"
          fill={color}
          opacity="1"
          data-original="#000000"
        ></circle>
        <path
          d="M24.1 38.2c0-3.2-2.6-5.8-5.8-5.8s-5.8 2.6-5.8 5.8 2.6 5.8 5.8 5.8 5.8-2.6 5.8-5.8z"
          fill={color}
          opacity="1"
          data-original="#000000"
        ></path>
        <circle
          cx="52.6"
          cy="50.1"
          r="5.8"
          fill={color}
          opacity="1"
          data-original="#000000"
        ></circle>
        <circle
          cx="38.9"
          cy="50.1"
          r="5.8"
          fill={color}
          opacity="1"
          data-original="#000000"
        ></circle>
        <path
          d="M25.1 44.3c-3.2 0-5.8 2.6-5.8 5.8s2.6 5.8 5.8 5.8c3.3 0 5.8-2.6 5.8-5.8.1-3.2-2.6-5.8-5.8-5.8z"
          fill={color}
          opacity="1"
          data-original="#000000"
        ></path>
        <circle
          cx="11.4"
          cy="50.1"
          r="5.8"
          fill={color}
          opacity="1"
          data-original="#000000"
        ></circle>
      </g>
    </svg>
  );
};
